import React from 'react';
import { Section } from './Section';

const categories = [
    {
        title: 'Languages',
        skills: ['Java', 'SQL', 'C', 'C#', 'Python', 'GDScript', 'TypeScript'],
        primary: 'Java',
    },
    {
        title: 'Frameworks & libraries',
        skills: ['Spring Boot', 'React', 'Godot', 'Flutter', 'Angular', 'JavaFX', 'OpenCV'],
        primary: null as string | null,
    },
    {
        title: 'Tools',
        skills: ['Docker', 'Git (GitHub, GitLab)', 'Postman', 'RaspberryPi', 'AWS'],
        primary: null as string | null,
    },
];

export const SkillsSection: React.FC = () => {
    return (
        <Section title="Skills & tools">
            <dl className="m-0 flex flex-col gap-4">
                {categories.map(cat => (
                    <div key={cat.title} className="grid gap-2 sm:grid-cols-[11rem_1fr] sm:gap-6 items-baseline">
                        <dt className="label">{cat.title}</dt>
                        <dd className="m-0 text-ink">
                            {cat.skills.map((skill, i) => (
                                <React.Fragment key={skill}>
                                    {skill === cat.primary
                                        ? <strong className="font-semibold">{skill}</strong>
                                        : skill}
                                    {i < cat.skills.length - 1 && ', '}
                                </React.Fragment>
                            ))}
                        </dd>
                    </div>
                ))}
            </dl>
        </Section>
    );
};
